const abroadMethods = {
  PostCollaborationInsurance: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ledgertech/connectTokenToSession',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['Scope', 'ClientId', 'ClientSecret', 'LoginType', 'Sid', 'SubscriberNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
  },

  GetCollaborationInsuranceData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Abroad/GetCollaborationInsuranceData',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['phoneNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  FetchFamilyBundleUsages: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Abroad/FetchFamilyBundleUsages',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['subscriber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  GetAbroadAdditionalServices: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Abroad/GetAbroadAdditionalServices',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['phoneNumber', 'addonsFolderBlockId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  IsCollaborationInsuranceAllowed: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Abroad/IsCollaborationInsuranceAllowed',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['phoneNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  getAbroadMatchPackageGuest: {
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,
    apiSuffixName: 'abroad/GetMatchPackage',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['CountryCodeList', 'DateStart', 'DateEnd', 'BlockId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  getAbroadMatchPackage: {
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,

    endPointContext: {
      ANONYMOUS: {
        apiSuffixName: 'abroad/GetMatchPackage',
      },
      AUTHENTICATED: {
        apiSuffixName: 'abroad/GetMatchPackageAuth',
      },
    },
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['CountryCodeList', 'DateStart', 'DateEnd', 'BlockId', 'PhoneNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getAbroadMatchPackageBusinessIndividual: {
    online: true,
    requiredLogin: true,

    apiSuffixName: 'abroad/GetMatchPackageBusinessIndividual',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['CountryCodeList', 'DateStart', 'DateEnd', 'BlockId', 'GoldBusinessPackagesBlockId', 'PhoneNumber', 'OrgId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getAbroadPackagePopular: {
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,

    endPointContext: {
      ANONYMOUS: {
        apiSuffixName: 'abroad/GetPackagePopular',
      },
      AUTHENTICATED: {
        apiSuffixName: 'abroad/GetPackagePopularAuth',
      },
    },
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['SocIdList', 'BlockId', 'ClientType', 'shadowFilter', 'IsReducedSocList'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getAbroadPackageDetails: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Abroad/Package',
    httpMethod: 'get',

    isJsonRequest: false,
    getArgumentName: ['packageBlockId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getAbroadPackageDetailsBySocCode: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Abroad/Package/Terms',
    httpMethod: 'get',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: ['socCode'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getAbroadFamilyPackageDetails: {
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,
    endPointContext: {
      ANONYMOUS: {
        apiSuffixName: 'abroad/GetFamilyPackageDetails',
      },
      AUTHENTICATED: {
        apiSuffixName: 'abroad/GetFamilyPackageDetailsAuth',
      },
    },
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['blockId', 'codeSoc', 'phoneNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  ValidateFamilyPackage: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/ValidateFamilyPackageAuth',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [
      'SubscriberNoParent',
      'SubscriberChildren',
      'SocCodeFamilyPackage',
      'SocCodePackageGiveFamilyBonus',
      'StartDateParent',
      'EndDateChildren',
      'StartDateChildren',
      'Countries',
      'BlockId',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  FamilySocData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/FamilySocData',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['phoneNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetUnqualifiedSubsFamily: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/GetUnqualifiedSubsAuth',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['SubscriberNoParent', 'SocCodePackageGiveFamilyBonus', 'StartDateParent'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  AddFamilyPackage: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/AddFamilyPackageAuth',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [
      'SubscriberNoParent',
      'soc',
      'startDate',
      'endDate',
      'countries',
      'blockId',
      'shouldRemoveSurfingBlockage',
      'type',
      'OtpTicketChildren',
      'SubscriberChildren',
      'startDateParent',
      'socCodePackageGiveFamilyBonus',
      'flightManager',
      'selectedMembers',
      'couponCode',
      'couponSerial',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getCellcomAbroadEpiGeneralData: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'abroad/AbroadGeneralInfo',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  abroadCountriesSearched: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'abroad/AbroadCountriesSearched',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['input'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getCustomerAbroadPackages: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/GetCustomerAbroadPackagesAuth',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['mobile', 'privateBlockId', 'businessBlockId', 'addonsFolderBlockId', 'goldBusinessPackagesBlockId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  validateCustomerType: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/AbroadRetrieveCustomerDataAuth',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['phoneNumber', 'type'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  validateCustomerTypeBusinessIndividual: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/AbroadRetrieveCustomerDataBusinessIndividual',
    timeout: 37000,
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['phoneNumber', 'type', 'orgId', 'startDate', 'endDate', 'countries', 'socCode', 'packageSegment'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  abroadRetrieveCustomerData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/AbroadRetrieveCustomerDataAuth',

    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['phoneNumber', 'socCode', 'startDate', 'endDate', 'type', 'countries', 'blockId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  abroadRemoveAndAddSoc: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/AddPackageAuth',
    httpMethod: 'put',
    isJsonRequest: true,
    getArgumentName: [
      'subscriberNumber',
      'soc',
      'startDate',
      'endDate',
      'countries',
      'blockId',
      'shouldRemoveSurfingBlockage',
      'type',
      'signCollaborationApproval',
      'isShelfEpi',
      'flightManager',
      'selectedMembers',
      'removedMembers',
      'couponCode',
      'couponSerial',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  addAddonToPackage: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/AddAddonToPackage',
    httpMethod: 'put',
    isJsonRequest: true,
    getArgumentName: ['subscriberNumber', 'soc', 'startDate', 'countries', 'accountType', 'addonType', 'parentSocCode', 'blockId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  abroadRemoveAndAddSocBusinessIndividual: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/AbroadRemoveAndAddSocBusinessIndividual',
    httpMethod: 'put',
    isJsonRequest: true,
    getArgumentName: [
      'subscriberNumber',
      'soc',
      'startDate',
      'endDate',
      'countries',
      'shouldRemoveSurfingBlockage',
      'type',
      'orgId',
      'blockId',
      'isShelfBusinessIndividual',
      'allowIndependentFuturePurchases',
      'isSplitBuy',
      'packageType',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  abroadAddSoc: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/AddSinglePackageAuth',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['phoneNumber', 'socCode'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  abroadUpdateSoc: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/UpdatePackageAuth',
    httpMethod: 'put',
    isJsonRequest: true,
    getArgumentName: ['phoneNumber', 'soc', 'effDate', 'expDate', 'newDateToUpdate', 'blockId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  retrieveCustomerAbroadUsageData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/RetrieveCustomerAbroadUsageDataAuth',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['subscriber', 'toReport'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  retrieveCustomerAbroadMagicLinkUsageData: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'abroad/RetrieveCustomerAbroadMagicLinkUsageDataAuth',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['subscriber', 'toReport'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getExtendedPackageData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/AbroadGetExtendedPackageDataAuth',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['blockId', 'userType', 'phoneNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getCustomerAbroadUsageDisplay: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/GetMyAbroadUsageAuth',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['mobile'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getRetrieveTariffPrices: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'abroad/RetrieveTariffPrices',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['country', 'soc', 'blockId'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  removePackage: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/removePackageAuth',
    httpMethod: 'put',
    isJsonRequest: true,
    getArgumentName: ['soc', 'mobile', 'startDate', 'shouldRemoveSurfingBlockSoc', 'blockId', 'isAddon'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  removeCapSoc: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/RemoveCapSocAuth',
    httpMethod: 'put',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetShadowSubscriber: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/GetShadowSubscriberAuth',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['subscriber'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  GetDebtIssuesIndicator: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/GetDebtIssuesIndicatorAuth',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['id', 'subscriber'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  PlantMemoBeforePurchase: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/PlantMemoBeforePurchaseAuth',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['banId', 'soc', 'subscriber', 'countries', 'startDate', 'endDate'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  UpdateCustomerEmail: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/UpdateCustomerEmailAuth',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['ban', 'email', 'subscriber'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getAddonsPackageByBlockId: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'abroad/GetAddonsPackageByBlockId',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: ['blockId'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  CreateShadowCustomer: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/CreateShadowCustomerAuth',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: ['idNumber', 'firstName', 'lastName', 'subscriber', 'ccMonth', 'ccYear', 'ccType', 'ccNumber', 'clientMail'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  UpdateShadowCC: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/UpdateShadowCCAuth',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['ccMonth', 'ccYear', 'ccType', 'ccNumber', 'banId', 'clientId', 'subscriber', 'authNo'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  RemoveAndAddShadowSoc: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/AddShadowPackageAuth',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [
      'idNumber',
      'firstName',
      'lastName',
      'subscriber',
      'ccMonth',
      'ccYear',
      'ccType',
      'ccNumber',
      'authNum',
      'clientMail',
      'socCode',
      'referenceSocCode',
      'shadowBan',
      'startDate',
      'endDate',
      'countries',
      'blockId',
      'fromExisting',
      'allowIndependentFuturePurchases',
      'couponSerial',
      'couponCode',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  PlantShadowMemo: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/PlantShadowMemoAuth',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['banId', 'soc', 'subscriber', 'shadowBan', 'memoType'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  RetrieveShadowClientBillData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/RetrieveShadowClientBillDataAuth',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['subscriber'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getCustomerAbroadPackagesBusinessIndividual: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'abroad/GetCustomerAbroadPackagesBusinessIndividual',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['phoneNumber', 'goldBusinessPackagesBlockId', 'blockId', 'orgId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  validateAbroadCoupon: {
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,
    apiSuffixName: 'abroad/AbroadCouponValidation',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['soc_code', 'coupon_code', 'phoneNumber', 'channel'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
};

export default abroadMethods;
